import { Component, ViewChild, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageChangeEvent, RowArgs } from '@progress/kendo-angular-grid';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-grid',
    templateUrl: './dispatch-grid.component.html',
    styleUrls: ['./dispatch-grid.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchGridComponent extends BaseGridComponent<v_DispatchBus, null>  {

    compFeatureFlagSet: IFeatureFlagSet = this as any;

    searchParam: WidgetSearch;
    subscriptions: Subscription[] = [];
    public filter: CompositeFilterDescriptor;
    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.originalGridData, filter);
        this.processGridData();
    }
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.generalWidgetRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }));

    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();
    loaderState: boolean = true;
    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    exportFilteredData: any[];

    initialLoad: boolean = true;

    ngOnInit() {
        //this.titleChild.emit(null); //('Open Dispatches - Detail');
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    public sort: SortDescriptor[] = [{
        field: 'dispatchNumber',
        dir: 'asc'
    }];
    public sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
    }
    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_data.getStatusDetailByWidgetSearch(this.searchParam).subscribe(data => {
            if (data == null || data.length == 0) {
                this.handleNetworkError(null);
            } else {
                this.data = data;

                this.originalGridData = _.cloneDeep(data);
                this.gridData = orderBy(filterBy(this.originalGridData, this.filter),this.sort);

                this.loaderState = false;
                if (this.lastIdLoaded) {
                    this.selection = [];
                    this.selection.push(this.lastIdLoaded);
                    this.state.skip = this.lastSkip;
                    this.lastIdLoaded = null;
                }

            }
        },
            error => this.handleNetworkError(error));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    public pageChange(event: PageChangeEvent): void {
        this.state.skip = event.skip;
    }
    lastIdLoaded: string = null;
    lastSkip = null;
    public selection: string[] = [];
    public selectionKey(context: RowArgs): string {
        return context.dataItem.dispatchId;
    }

    showDetailsPopup(id: string, type: number) {
        this.grid
        this.lastIdLoaded = id;
        this.selection = [];
        this.selection.push(this.lastIdLoaded);
        this.lastSkip = this.state.skip;
        this.svc_dashboard.openDQOIPopup(id, type);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
                && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
}
